import { Skeleton, Stack, Typography } from "@mui/material";
import React, { type MouseEventHandler } from "react";
import { useNavigate } from "react-router-dom";
import "./TableHeader.scss";

export interface HeaderTitle {
  content: string;
  path?: string;
  state?: Record<string, any>;
  onClick?: MouseEventHandler<HTMLSpanElement>;
}

export const TableHeaderTitles = ({
  titles,
  loading = false,
  disableNavigation = false,
}: {
  titles: HeaderTitle[];
  loading?: boolean;
  disableNavigation?: boolean;
}) => {
  const navigate = disableNavigation ? undefined : useNavigate();

  return (
    <Stack direction="row" className="titles-container">
      {loading
        ? (titles.length ? titles : [0]).map((key, i, arr) => (
          <React.Fragment key={"placeholder" + i}>
            <Skeleton animation="wave" width="5.5vw" height="1.5rem" />
            {i !== arr.length - 1 && (
              <span className="divider">{" >> "}</span>
            )}
          </React.Fragment>
        ))
        : titles.map((head, index) => (
          <React.Fragment key={head.content + index}>
            <Typography
              className="title"
              onClick={(e) => {
                head.onClick?.(e);
                if (head.path) navigate?.(head.path, { state: head.state });
              }}
              sx={{
                cursor: head.onClick || head.path ? "pointer" : "default",
              }}
            >
              {head.content}
            </Typography>
            {index !== titles.length - 1 && (
              <span className="divider">{" >> "}</span>
            )}
          </React.Fragment>
        ))}
    </Stack>
  );
};
